import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {MenuOption, NODE_TYPE} from "./menuOption";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {DisplayTypeModalData} from "../../templates/display-type-dialog/displayTypeUtils";
import {ActiveFormService} from "../../../../../services/active-form.service";
import {MatAccordion} from "@angular/material/expansion";
import {COLLAPSE_EXPAND_STATE, COLLAPSE_TOOLTIP_MESSAGE} from "../multiple-choice/multipleChoice";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import isEmpty from 'lodash/isEmpty';

@Component({
    selector: 'app-menu-option',
    templateUrl: './menu-option.component.html',
    styleUrls: ['./menu-option.component.scss']
})
export class MenuOptionComponent extends NodeBuilder implements OnInit, OnDestroy {

    menuOptionForm: FormGroup;
    displayTypeModalData: DisplayTypeModalData = undefined;
    optionCount: number = 0;
    optionSeperatorList: string[] = ['. ', '- '];

    collapseExpandStates: COLLAPSE_EXPAND_STATE = COLLAPSE_EXPAND_STATE.OPEN;
    collapseExpandTooltip: COLLAPSE_TOOLTIP_MESSAGE = COLLAPSE_TOOLTIP_MESSAGE.EXPANDED;

    readonly KEYWORD_FIELD = {
        dataType: 'keyword',
        type: 'chips',
        label: '',
        placeholder: 'Add keyword(s)',
        validators: {
            maxLength: 5,
            duplicate: true,
        },
    };


    @ViewChild("formContainer") formContainer: ElementRef;

    constructor(private activeFormService: ActiveFormService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.activeFormService.clearFocus();
    }

    set buildForm(stepData: any) {

        this.menuOptionForm = MenuOption.toForm(stepData, this.canEdit);
        const options: FormArray = this.menuOptionForm.get("options") as FormArray
        this.optionCount = options.length + 1;

        this.setDisplayType();

        if (!stepData) {
            for (let option of options.getRawValue()) {
                if (option.get('next').value === newStepValue) {
                    option.get('next').setValue('step' + this.getNextStep());
                }
            }
        }

    }

    get getStepData(): {} {
        const menuOption = new MenuOption();
        menuOption.setNodeData(this.menuOptionForm.getRawValue())
        return menuOption.nodeData;
    }

    get isNodeValid(): boolean {
        this.menuOptionForm.markAllAsTouched();
        return this.menuOptionForm.valid;
    }

    public setImage(event, form): void {
        form.get('imageRef').setValue(event);
    }

    public displayChange(event) {
        this.activeFormService.setActiveForm(this.menuOptionForm);
        this.patchDisplayType(event);
    }

    private setDisplayType() {
        this.displayTypeModalData = {
            isDirty: false,
            displayType: this.menuOptionForm.get('displayTypes').value,
            customListButton: this.menuOptionForm.get("customListButton").value
        }
    }

    private patchDisplayType(event) {
        if (event) {
            const displayTypeFormGroup: FormGroup = this.menuOptionForm.get('displayTypes') as FormGroup
            MenuOption.buildDisplayTypesForm(displayTypeFormGroup, event.displayType)
            if (event.isDirty) {
                displayTypeFormGroup.markAsDirty();
            }
            this.menuOptionForm.get('customListButton').setValue(event?.customListButton);
        }
    }

    public addSeparator(e, valueInput): void {
        e.stopPropagation();
        if (valueInput !== '') {
            this.optionSeperatorList.push(valueInput);
        }
    }

    public collapseExpandLogic(accordion: MatAccordion): void {

        if (this.collapseExpandStates === COLLAPSE_EXPAND_STATE.OPEN) {

            this.collapseExpandTooltip = COLLAPSE_TOOLTIP_MESSAGE.EXPANDED;
            this.collapseExpandStates = COLLAPSE_EXPAND_STATE.CLOSE;

            accordion.closeAll();
            return;
        }

        accordion.openAll();
        this.collapseExpandTooltip = COLLAPSE_TOOLTIP_MESSAGE.COLLAPSED;
        this.collapseExpandStates = COLLAPSE_EXPAND_STATE.OPEN;
        return;
    }

    public deleteOption(index: number) {
        const options = this.menuOptionForm.get('options') as FormArray;
        options.removeAt(index);

    }

    public addOption() {
        const options = this.menuOptionForm.get('options') as FormArray;
        options.push(MenuOption.optionTemplate({
            text: "",
            imageRef: "",
            keywords: [],
            bodyText: "",
            next: newStepValue,
        }, this.canEdit.canEditFlows))

        setTimeout(() => {
            if (this.formContainer) {
                const element = this.formContainer.nativeElement;
                element.scrollTo({top: element.scrollHeight, behavior: 'smooth'})
            }
        })
    }

    public drop(event: CdkDragDrop<FormArray[]>, accordion: MatAccordion) {
        if (event.previousContainer === event.container) {
            const options = this.menuOptionForm.get('options') as FormArray;
            const currentList = options.getRawValue();
            moveItemInArray(currentList, event.previousIndex, event.currentIndex);
            options.patchValue(currentList);
        }
    }


}
